import UniversalRouter, { RouteParams, Routes } from 'universal-router';

import { Page } from './Page';
import { Front } from './Front';

import { ProductPage } from './product';
import { SearcherPage } from './searcher';

type Result = {
    params: RouteParams,
    page: Page
};

const children: Routes<Result> = [
    {
        path: [
            '/',
        ],
        action: (ctx, params): Result => ({ params, page: Front }),
    },
    {
        path: [
            '/ficha/guantes/:gloves',
            '/ficha/accesorios-de-seguridad/:accesory',
            '/ficha/vestuario-laboral/:clothing',
        ],
        action: (ctx, params): Result => ({ params, page: ProductPage }),
    },
    {
        path: [
            '/productos/guantes',
            '/productos/guantes/(.*)',
            '/productos/accesorios-de-seguridad',
            '/productos/accesorios-de-seguridad/(.*)',
            '/productos/vestuario-laboral',
            '/productos/vestuario-laboral/(.*)',
            '/productos/vestuario-laboral-y-accesorios',
            '/productos/vestuario-laboral-y-accesorios/(.*)',
        ],
        action: (ctx, params): Result => ({ params, page: SearcherPage }),
    },
];

const routes: Routes<Result> = [
    { path: '', children },
    { path: '/:lang?', children },
];

export const router = new UniversalRouter<Result>(routes);
